import { TimeValidationError } from "./TimeValidationError";
import { TimeValidationResult } from "./TimeValidationResult";

const EMPTY_REGEX = /^\s*$/;
const ONLY_DIGITS_REGEX = /^\d+$/;
const HOURLY_REGEX = /^(?:(?<hours>\d+)h)?\s*(?:(?<minutes>\d+)m)?$/;

export const validateHourlyFormattedTime = (
  formattedTime: string,
  onSuccess: (result: TimeValidationResult) => void,
  onError: (error: TimeValidationError) => void,
) => {
  const input = formattedTime.trim();

  const emptyMatch = EMPTY_REGEX.exec(input);
  if (emptyMatch !== null) {
    return onSuccess({
      reportedTime: 0,
      input: "",
    });
  }

  const onlyDigitsMatch = ONLY_DIGITS_REGEX.exec(input);
  if (onlyDigitsMatch !== null) {
    const hours = Number.parseInt(onlyDigitsMatch[0], 10);

    return onSuccess({
      reportedTime: hours * 60,
      input,
    });
  }

  const hourlyMatch = HOURLY_REGEX.exec(input);
  if (
    hourlyMatch !== null &&
    (typeof hourlyMatch.groups?.hours === "string" || typeof hourlyMatch.groups?.minutes === "string")
  ) {
    const maybeHours = Number.parseInt(hourlyMatch.groups?.hours, 10);
    const maybeMinutes = Number.parseInt(hourlyMatch.groups?.minutes, 10);

    const hours = Number.isInteger(maybeHours) ? maybeHours : 0;
    const minutes = Number.isInteger(maybeMinutes) ? maybeMinutes : 0;

    return onSuccess({
      reportedTime: hours * 60 + minutes,
      input,
    });
  }

  return onError("WRONG_FORMAT");
};
